import { useMediaQuery } from '@space-core/hooks'
import { ScreenSizes } from '@space-core/styles'
import clsx from 'clsx'

import styled from 'styled-components'

import Carousel from '../../carousel'

import { GridOrientation } from '../enum'
import type { BaseGridProps } from '../types'

const GridMobile = styled.div<{ gridOrientation?: GridOrientation; isTablet?: boolean }>`
  display: grid;

  ${({ gridOrientation, isTablet }) =>
    gridOrientation === GridOrientation.HORIZONTAL
      ? `
      grid-gap: var(--spacer-5);
      grid-template-columns: repeat(auto-fit, minmax(12.75rem, 1fr));
    `
      : `
      grid-gap: var(--spacer-4);
      grid-template-columns: repeat(auto-fit, minmax(${isTablet ? '10rem' : '14.75rem'}, 1fr));
    `}
`

const GridDefaultMobile = ({ children, isCarousel, gridOrientation, className }: BaseGridProps) => {
  const gridMobileClass = clsx('_align-items-start', className)
  const isTablet = useMediaQuery(`(max-width: ${ScreenSizes.sm})`)

  return (
    <>
      {isCarousel ? (
        <Carousel className={className}>{children}</Carousel>
      ) : (
        <GridMobile
          className={gridMobileClass}
          gridOrientation={gridOrientation}
          isTablet={isTablet}
          data-test='mobile-base-grid'>
          {children}
        </GridMobile>
      )}
    </>
  )
}

export default GridDefaultMobile
